import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import type { QTooltipProps } from 'quasar'

interface IProps {
  description: string
  model?: 'info' | 'warning' | 'error'
  title?: string
  icon?: string
  iconColor?: string
  iconSize?: string
  hasAlertIcon?: boolean
  containerClass?: string
  position?:
    | 'side-left-up'
    | 'side-left-down'
    | 'side-right-up'
    | 'side-right-down'
    | 'left-up'
    | 'right-up'
    | 'left-down'
    | 'right-down'
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KCallout', inheritAttrs: false },
  __name: 'KCallout',
  props: {
    description: {},
    model: { default: 'info' },
    title: { default: '' },
    icon: { default: 'question' },
    iconColor: { default: '' },
    iconSize: { default: '20px' },
    hasAlertIcon: { type: Boolean, default: false },
    containerClass: { default: '' },
    position: { default: 'side-left-up' }
  },
  setup(__props: any) {



const props = __props

const tooltipOptions = computed(() => {
  const positionMappings = {
    'side-left-up': {
      icon: 'info-right',
      anchor: 'top right',
      self: 'top left',
      offset: [10, 20],
    },
    'side-left-down': {
      icon: 'info-right',
      anchor: 'bottom right',
      self: 'bottom left',
      offset: [10, 20],
    },
    'side-right-up': {
      icon: 'info-left',
      anchor: 'top left',
      self: 'top right',
      offset: [10, 20],
    },
    'side-right-down': {
      icon: 'info-left',
      anchor: 'bottom left',
      self: 'bottom right',
      offset: [10, 20],
    },
    'left-up': {
      icon: 'info-down',
      anchor: 'bottom left',
      self: 'top left',
      offset: [20, 10],
    },
    'right-up': {
      icon: 'info-down',
      anchor: 'bottom right',
      self: 'top right',
      offset: [20, 10],
    },
    'left-down': {
      icon: 'info-top',
      anchor: 'top left',
      self: 'bottom left',
      offset: [20, 10],
    },
    'right-down': {
      icon: 'info-top',
      anchor: 'top right',
      self: 'bottom right',
      offset: [20, 10],
    },
  }

  return (positionMappings[props.position] || {
    icon: '',
    anchor: '',
    self: '',
    offset: [0, 0],
  }) as Partial<QTooltipProps>
})

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_KAlert = _resolveComponent("KAlert")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["relative-position flex inline", [__props.containerClass]])
  }, [
    _createVNode(_component_KIcon, {
      size: __props.iconSize,
      name: __props.icon,
      color: __props.iconColor
    }, null, 8 /* PROPS */, ["size", "name", "color"]),
    _createVNode(_component_q_tooltip, _mergeProps({
      class: "k-callout q-pa-none rounded-16 bg-transparent shadow-3 fs-13px",
      offset: tooltipOptions.value.offset,
      anchor: tooltipOptions.value.anchor,
      self: tooltipOptions.value.self
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        _createVNode(_component_KAlert, {
          model: __props.model,
          description: __props.description,
          title: __props.title,
          "has-icon": __props.hasAlertIcon
        }, null, 8 /* PROPS */, ["model", "description", "title", "has-icon"])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["offset", "anchor", "self"])
  ], 2 /* CLASS */))
}
}

})